/**
 * Help Center type definitions
 */

export interface HelpArticleData {
  id: string;
  title: string;
  category: HelpCategory;
  content: string;
  summary: string;
  keywords: string[];
  relatedArticles?: string[];
  lastUpdated: string;
  feature?: string; // Maps to feature flag for conditional display
  plugin?: string;  // Maps to plugin ID for plugin-specific help
  priority?: number; // Higher number = higher priority (default: 0)
  subcategory?: string; // Subcategory within feature (e.g., "Getting Started", "End-to-End Workflows")
  comingSoon?: boolean; // Mark articles that are not yet available
}

export type HelpCategory = 
  | 'getting-started'
  | 'knowledge-base'
  | 'entities'
  | 'reports'
  | 'rag-chat'
  | 'sources'
  | 'jobs'
  | 'admin'
  | 'troubleshooting'
  | 'plugins';

export interface HelpCategoryInfo {
  id: HelpCategory;
  name: string;
  description: string;
  icon: string;
  order: number;
}

export interface HelpCenterConfig {
  enabled: boolean;
  supportEmail?: string;
  supportUrl?: string;
  feedbackEnabled?: boolean;
  customArticles?: HelpArticleData[];
}

export const HELP_CATEGORIES: HelpCategoryInfo[] = [
  { 
    id: 'getting-started', 
    name: 'Getting Started', 
    description: 'Learn the basics of using the platform',
    icon: 'rocket',
    order: 1
  },
  { 
    id: 'knowledge-base', 
    name: 'Knowledge Base', 
    description: 'Managing documents and artifacts',
    icon: 'folder',
    order: 2
  },
  { 
    id: 'entities', 
    name: 'Entities', 
    description: 'Working with structured data and entities',
    icon: 'database',
    order: 3
  },
  { 
    id: 'reports', 
    name: 'Reports', 
    description: 'Creating and managing reports',
    icon: 'file-text',
    order: 4
  },
  { 
    id: 'rag-chat', 
    name: 'AI Search & Chat', 
    description: 'Using evidence-based search and Q&A',
    icon: 'message-circle',
    order: 5
  },
  { 
    id: 'sources', 
    name: 'Data Sources', 
    description: 'Connecting external databases',
    icon: 'link',
    order: 6
  },
  { 
    id: 'jobs', 
    name: 'Background Jobs', 
    description: 'Understanding processing jobs',
    icon: 'clock',
    order: 7
  },
  { 
    id: 'admin', 
    name: 'Administration', 
    description: 'Team and workspace management',
    icon: 'settings',
    order: 8
  },
  { 
    id: 'troubleshooting', 
    name: 'Troubleshooting', 
    description: 'Common issues and solutions',
    icon: 'help-circle',
    order: 9
  },
  { 
    id: 'plugins', 
    name: 'Plugins & Extensions', 
    description: 'Plugin-specific features',
    icon: 'puzzle',
    order: 10
  },
];





